import type { IconProps } from './types';

export const IconPrint: React.FC<IconProps> = (props) => {
    return (
        <svg {...props} id="icoPrint" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <rect id="Rectangle_5067" data-name="Rectangle 5067" width="24" height="24" fill="none" />
            <g id="Group_12117" data-name="Group 12117" transform="translate(0.537 0.497)">
                <path
                    id="Path_5512"
                    data-name="Path 5512"
                    d="M15.757,2.75H7.851a.966.966,0,0,0-.991.942V7.45h9.888V3.692A.966.966,0,0,0,15.757,2.75Z"
                    transform="translate(-0.341)"
                    fill="none"
                    stroke="#1e2124"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5"
                />
                <path
                    id="Path_5513"
                    data-name="Path 5513"
                    d="M3.419,10.091a1.5,1.5,0,0,1,1.5-1.514h13.1a1.5,1.5,0,0,1,1.5,1.514v4.4A1.5,1.5,0,0,1,18.011,16H16.327V17.44h1.684a2.929,2.929,0,0,0,2.915-2.951v-4.4A2.929,2.929,0,0,0,18.011,7.14H4.915A2.929,2.929,0,0,0,2,10.091v4.4A2.929,2.929,0,0,0,4.915,17.44H6.6V16H4.915a1.5,1.5,0,0,1-1.5-1.514Z"
                    transform="translate(0 -0.308)"
                    fill="#1e2124"
                />
                <path
                    id="Path_5514"
                    data-name="Path 5514"
                    d="M16.748,12H6.86v7.318A1.308,1.308,0,0,0,8.187,20.6h7.233a1.308,1.308,0,0,0,1.327-1.283Z"
                    transform="translate(-0.341 -0.344)"
                    fill="none"
                    stroke="#1e2124"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5"
                />
                <path
                    id="Path_5515"
                    data-name="Path 5515"
                    d="M9.94,18.17H10.9"
                    transform="translate(-0.419 -0.777)"
                    fill="none"
                    stroke="#1e2124"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5"
                />
                <path
                    id="Path_5516"
                    data-name="Path 5516"
                    d="M9.94,15.08h3.831"
                    transform="translate(-0.392 -0.662)"
                    fill="none"
                    stroke="#1e2124"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5"
                />
            </g>
        </svg>
    );
};
